module.exports = __webpack_public_path__ + "76f9d914f810f68d09e8db0c7d6014d6.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/star.svg
// module id = 1492
// module chunks = 1 4 7 22 24 80